import getPageTag from './pageTag';
import getRadioOnChangeTags from './radioOnChangeTag';
const getSpecs = (state) => {

  return [
    getPageTag(state),
    getRadioOnChangeTags(state),
  ];
};

export default getSpecs;
